import classNames from 'classnames';
import * as React from 'react';
import { ComponentProps } from 'react';

import wrapChildren from '../../helpers/react/wrapChildren';
import Space from '../../types/UI/Space';
import Box from '../Box/Box';

import styles from './Inline.module.css';

type InlineProps = {
    className?: string;
    space?: Space;
    horizontal?: ComponentProps<typeof Box>['horizontal'];
    vertical?: ComponentProps<typeof Box>['vertical'];
    flex?: ComponentProps<typeof Box>['flex'];
    children: React.ReactNode;
    reverse?: boolean;
    /* Specify one flex for all or an array to target the specific children */
    flexChildren?: number | Array<number | undefined>;
    flexBasisChildren?: number | Array<number | undefined>;
};

const Inline = ({
    children,
    className,
    space = 'medium',
    horizontal = 'left',
    vertical = 'top',
    reverse,
    flex,
    flexChildren,
    flexBasisChildren,
}: InlineProps) => {
    const classes = classNames(className, {
        [styles.Root]: true,
        [styles.spaceXSmall]: space === 'xsmall',
        [styles.spaceSmall]: space === 'small',
        [styles.spaceMedium]: space === 'medium',
        [styles.spaceLarge]: space === 'large',
        [styles.spaceXLarge]: space === 'xlarge',
    });

    const childClasses = classNames(styles.Child, {
        [styles.Child_spaceXSmall]: space === 'xsmall',
        [styles.Child_spaceSmall]: space === 'small',
        [styles.Child_spaceMedium]: space === 'medium',
        [styles.Child_spaceLarge]: space === 'large',
        [styles.Child_spaceXLarge]: space === 'xlarge',
    });

    return (
        <Box
            className={classes}
            horizontal={horizontal}
            vertical={vertical}
            reverse={reverse}
            flex={flex}
            wrap
        >
            {wrapChildren(
                React.Children.toArray(children),
                (child, key, index) => {
                    const flex = Array.isArray(flexChildren)
                        ? flexChildren[index]
                        : flexChildren;

                    const flexBasis = Array.isArray(flexBasisChildren)
                        ? flexBasisChildren[index]
                        : flexBasisChildren;

                    return (
                        <div
                            className={childClasses}
                            key={key}
                            style={{ flex: flex, flexBasis: flexBasis }}
                        >
                            {child}
                        </div>
                    );
                }
            )}
        </Box>
    );
};

export default Inline;
